import React from 'react';
import './NivelBadge.scss';

var NivelBadge = function({ isDiamante, senha }) {
  if (isDiamante == null) {
    return (
      <span className="nivel-badge nivel-badge-sem-nivel">
        {senha}
      </span>
    );
  }
  var classe = isDiamante ? 'nivel-badge-diamante' : 'nivel-badge-topazio';
  var prefixo = isDiamante ? 'D' : 'T';
  return (
    <span className={'nivel-badge ' + classe}>
      {prefixo}-{senha}
    </span>
  );
};

export default NivelBadge;
